import React from "react";
import { Modal, Button, Text, Stack } from "@mantine/core";
import { useTranslation } from "react-i18next";

export default function MembershipRequiredModal({ setView }) {
  const { t } = useTranslation();
  return (
    <Modal opened={true} withCloseButton={false} centered>
      <Stack>
        <Text align="center" size="lg">
          {t("microsite:membership_required_modal_title")}
        </Text>
        <Button size="md" fullWidth onClick={() => setView("membership")}>
          {t("microsite:membership_required_modal_join_button")}
        </Button>
      </Stack>
    </Modal>
  );
}
